export default function removeNonBreakingSpaces(text: string): string {
  return text.replace(/\u00a0/g, " ");
}
